import { Injectable } from "@angular/core";
import { Computed, DataAction, Payload, StateRepository } from "@angular-ru/ngxs/decorators";
import { NgxsAfterBootstrap, State } from "@ngxs/store";
import { NgxsDataRepository } from "@angular-ru/ngxs/repositories";
import { GpioStatus } from "../../model";
import { BackendService } from "../../services/backend";

import { concat, switchMap, tap } from 'rxjs';
import { AuthenticationState } from "../auth/auth.state";
import { singleRequest } from "../index";

@StateRepository()
@State<GpioStatus>({
  name: 'gpio',
  defaults: {
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
  }
})
@Injectable()
export class GpioState extends NgxsDataRepository<GpioStatus> implements NgxsAfterBootstrap {
  constructor(private backend: BackendService,
    private authState: AuthenticationState) {
    super()
  }

  override ngxsAfterBootstrap() {
    super.ngxsAfterBootstrap();

    const gpioStatus$ =
      // this.authState.hasRole(UserRole.Admin) ? this.backend.getGpioStatus() :
      concat(
        this.backend.getGpioStatus(),
        this.backend.getGpioStatusUpdated()
      );
    gpioStatus$.subscribe(d => this.patchState(d))

    // The SSE `gpio` event carries only the pin that changed, so every event
    // missed while the stream was down is lost for good. Re-prime the full
    // snapshot on each reconnect, otherwise stale pins stay on screen until
    // someone reloads the page.
    this.backend.sseReconnected$
      .pipe(switchMap(() => this.backend.getGpioStatus()))
      .subscribe(d => this.patchState(d))
  }

  @Computed()
  public get asArray(): { id: number, value: boolean }[] {
    return Object.entries(this.snapshot).map(([id, value]) => ({ id: parseInt(id), value }))
  }

  @DataAction()
  public setGpio(@Payload('id') id: number, @Payload('value') value: boolean) {
    this.patchState({
      [id]: value
    });
    return this.backend.setGpioStatus(id, value).pipe(
      tap((status) => {
        this.patchState(status);
      }),
      singleRequest()
    )
  }


}
